import React, { useEffect, useState } from "react";
import {
  ActivityIndicator,
  Text,
  View,
  useWindowDimensions,
} from "react-native";
import { useQuery } from "react-query";
import { useDispatch, useSelector } from "react-redux";
import Header from "../components/Header";
import { getAllMatchesByAnalystId } from "../config/mainRequest";
import { FETCHED_ALL_MATCHES } from "../redux/actions/types";
import { encStr } from "../persistence/crypto/fieldCipher";
import SelectTournament from "./SelectTournament";
import { Stack } from "@mui/material";

const Home = () => {
  const dispatch = useDispatch();
  const [page, setPage] = useState(0);

  const { width } = useWindowDimensions();
  const isMobile = width < 850;

  const {
    loading,
    token,
    all_matches,
    analyst_id,
    isAdmin,
    analystName,
    accountRole,
    tabsAccessible,
  } = useSelector((state) => ({
    isAuthenticated: state.auth.isAuthenticated,
    login_error: state.auth.login_error,
    loading: state.auth.loading,
    m_error_msg: state.match.m_error_msg,
    all_matches: state.match.all_matches,
    analyst_id: state.auth.analyst_id,
    user: state.auth.user,
    token: state.auth.token,
    isAdmin: state.auth.isAdmin,
    analystName: state.auth.analystName,
    accountRole: state.auth.accountRole,
    tabsAccessible: state.auth.tabsAccessible,
  }));

  const [searchMatchId, setSearchMatchId] = useState();
  const [searchTournament, setSearchTournament] = useState();
  const [searchTeam, setSearchTeam] = useState();
  const [searchByAnalyzed, setSearchByAnalyzed] = useState();
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();

  const {
    data: _allMatches,
    isLoading: isLoadingMatches,
    isFetching: isFetching,
    isRefetching: isRefetching,
    refetch,
  } = useQuery({
    queryKey: [
      "allMatchesByAnalystId",
      analyst_id,
      token,
      page,
      searchMatchId,
      searchTournament,
      searchTeam,
      searchByAnalyzed,
      startDate,
      endDate,
      isAdmin,
    ],
    queryFn: () =>
      getAllMatchesByAnalystId({
        page,
        analyst_id,
        token,
        searchMatchId,
        searchTournament,
        searchTeam,
        searchByAnalyzed,
        startDate,
        endDate,
      }),
    keepPreviousData: true,
    enabled: Boolean(analyst_id && token),
    retry: false,
    refetchOnWindowFocus:false,
    select: (data) => {
      const allMatches = data;

      allMatches?.match_data?.data &&
        sessionStorage.setItem(
          "all_matches",
          encStr(JSON.stringify(allMatches?.match_data?.data))
        );
      return data;
    },
    onSuccess: (data) => {
      dispatch({
        type: FETCHED_ALL_MATCHES,
        payload: data?.match_data?.data,
      });
    },
    onError: (error) => {
      dispatch({
        type: FETCHED_ALL_MATCHES,
        payload: [],
      });
    },
  });

  // useEffect(() => {
  //   // dispatch(getAllMatches(analyst_id, token));
  //   dispatch({
  //     type: FETCHED_ALL_MATCHES,
  //     payload: _allMatches?.match_data?.data,
  //   });
  // }, [_allMatches, dispatch]);

  

  return (
    <View style={[styles.container]}>
      <Header username={analyst_id} tab="home" />
      {isLoadingMatches && (
        <View
          style={{ flex: 1, justifyContent: "center", alignItems: "center" }}
        >
          <ActivityIndicator size="large" />
          <Text style={{ fontFamily: "Roboto", fontSize: 18, opacity: 0.7, color: "var(--text-1)" }}>
            Fetching Matches
          </Text>
        </View>
      )}

      <Stack
        sx={{
          position: "relative",
          overflow: "auto",
          width: "100%",
          pt: 1.5,
          px: { xs: 1.5, md: 3 },
          boxSizing: "border-box",
        }}
      >
        {!isLoadingMatches ? (
          <SelectTournament
            isRefetching={isRefetching}
            onRefresh={refetch}
            count={_allMatches?.match_data?.count || 0}
            matchList={_allMatches || {}}
            isLoading={isLoadingMatches || isFetching || isRefetching}
            setPage={setPage}
            onPress={({
              page,
              searchMatchId,
              searchTournament,
              searchTeam,
              searchByAnalyzed,
              startDate,
              endDate,
            }) => {
              setSearchMatchId(searchMatchId);
              setSearchTournament(searchTournament);
              setSearchTeam(searchTeam);
              setSearchByAnalyzed(searchByAnalyzed);
              setStartDate(startDate);
              setEndDate(endDate);
              setPage(page);
            }}
          />
        ) : (
          !isLoadingMatches && (
            <View
              style={{
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Text
                style={{
                  fontFamily: "Roboto",
                  fontSize: isMobile ? 12 : 18,
                  opacity: 0.7,
                  color: "var(--text-1)"
                }}
              >
                Matches List Unavailable
              </Text>
            </View>
          )
        )}
      </Stack>
    </View>
  );
};

const styles = {
  container: {
    flex: 1,
    width: "100%",
    overflow: "hidden",
    justifyContent: "flex-start",
  },
};

export default Home;


